<template >
   <Renderer ref="renderer"   :alpha="true"   :antialias="true" resize="true">
    <Camera ref="camera" :position="{ z: 1200, y: -100 }" />
    <Scene ref="scene">
      <DirectionalLight color="#a861ff" intensity="0.5" :position="{ y: -200, z: 1000, x: 300 }" :shadowMapSize="{ width: 2000, height: 2000 }" />
      <DirectionalLight color="#a861ff" intensity="0.5" :position="{ y: -200, z: 1000, x: -300 }" :shadowMapSize="{ width: 2000, height: 2000 }" />
      <DirectionalLight color="#a861ff" intensity="0.2" :position="{ y: 200, z: 1000, x: 0 }" :shadowMapSize="{ width: 2000, height: 2000 }" />
      <FbxModel ref="model" src="/models/MyHead.fbx" @load="onReady" @progress="onProgress" @error="onError" />
    </Scene>
  </Renderer>
</template>
  
<script>
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

export default {
    name: "HeadComponent",
    data: () => ({

    }),
    async mounted() {
      
    },
    methods: {
      onReady() {
      
        const renderer = this.$refs.renderer.renderer;
        renderer.setClearColor( 0x000000, 0 );
        renderer.setClearAlpha(0);

        const camera = this.$refs.camera.camera;
        const orbitGroup = new THREE.Group();

        const scene = this.$refs.scene.scene;

        scene.add(orbitGroup);
        
      
        const controls = new OrbitControls(camera, renderer.domElement);
        controls.target.set(0, 0, 0);


        controls.enableZoom = false;
        controls.autoRotate = true;

        const objects = [];

        for (let i = 0; i < 5; i++) {

          let geometry;

        
          geometry = new THREE.IcosahedronGeometry(25, 0);
          

          const material = new THREE.MeshStandardMaterial({
            color: 0xD70DFF,
            metalness: 0.8,
            roughness: 0.2,
            emissive: 0x220044,
            emissiveIntensity: 0.5
          });

          const mesh = new THREE.Mesh(geometry, material);

          const radius = 200 + Math.random() * 370;
          const angle = Math.random() * Math.PI * 2;
          const height = (Math.random() - 0.5) * 400 * i;

          mesh.position.set(
            Math.cos(angle) * radius,
            height,
            Math.sin(angle) * radius
          );

          orbitGroup.add(mesh);
          objects.push(mesh);
        }



        const animate = () => {
          orbitGroup.rotation.y += 0.001;

          objects.forEach((obj, index) => {
            obj.rotation.x += 0.01 * (index % 3 + 1) * 0.2;
            obj.rotation.y += 0.005;
          });

          requestAnimationFrame(animate);
          controls.update();
          renderer.render(scene, camera);
        };

        animate();
      },
      onError(e){
          console.log(e);
      }
    },
  };
  </script>
  <style>

  canvas {
    background: transparent !important;
  }

  </style>